export enum AboutTabLabel {
  ABOUTBAMBEE = 'About',
  LEADERSHIP = 'Leadership',
  INVESTORS = 'Investors',
  TEAMS = 'Teams',
  CULTURE = 'Culture',
  // <--BEEREX-439--> This tab will be created before going to prod. <--BEEREX-439-->
  // BENEFITS = 'Benefits',
  HRMANAGERS = 'HR Managers',
  CAREERS = 'Careers',
}

export enum AboutTabValue {
  ABOUTBAMBEE = 'about',
  LEADERSHIP = 'leadership',
  INVESTORS = 'investors',
  TEAMS = 'teams',
  CULTURE = 'culture',
  // <--BEEREX-439--> This tab will be created before going to prod. <--BEEREX-439-->
  // BENEFITS = 'benefits',
  HRMANAGERS = 'hr-managers',
  CAREERS = 'careers',
}
